export interface Logger {
  debug(...args: unknown[]): void
  warn(...args: unknown[]): void
  error(...args: unknown[]): void
}

export function createLogger(debug: boolean): Logger {
  const noop = () => {}
  return {
    debug: debug ? console.debug.bind(console, '[@podo-app/analytics]') : noop,
    warn: console.warn.bind(console, '[@podo-app/analytics]'),
    error: console.error.bind(console, '[@podo-app/analytics]'),
  }
}
